import axios from 'axios'
import { LOGIKSPARK_CORE_API_URL, LOGIKSPARK_USERS_API_URL } from '../../app/axios/const'
import { CheckSubdomainResponse, RegisterTenantRequest, RegisterTenantResponse, SignupCurrency } from './types'

// Dedicated ANONYMOUS axios instances for the public /signup flow. The app's normal axios instances
// attach an MSAL bearer token (and throw when no account is signed in), so they're unusable here -- the
// signup form runs before any tenant/user exists. These carry only a Content-Type header. Base URLs
// already include the /api prefix (same as the authed instances), so routes are relative to it.
const usersAnon = axios.create({
  baseURL: LOGIKSPARK_USERS_API_URL,
  headers: { 'Content-Type': 'application/json' },
})

const coreAnon = axios.create({
  baseURL: LOGIKSPARK_CORE_API_URL,
  headers: { 'Content-Type': 'application/json' },
})

// All responses are wrapped in a ResponseDto envelope ({ data: <payload>, ... }), exactly like the
// authed fetchData unwraps via result.data.data.
export const checkSubdomain = async (subdomain: string, signal?: AbortSignal): Promise<CheckSubdomainResponse> =>
  (await usersAnon.get('/v1/signup/check-subdomain', { params: { subdomain }, signal })).data.data

export const getSignupCurrencies = async (): Promise<SignupCurrency[]> =>
  (await coreAnon.get('/currency/tenant-signup')).data.data

export const registerTenant = async (body: RegisterTenantRequest): Promise<RegisterTenantResponse> =>
  (await usersAnon.post('/v1/signup', body)).data.data
